module.exports = __webpack_public_path__ + "static/media/adapter.1de3f3d9.jpg";